import PropTypes from 'prop-types';
import React from 'react';
import classnames from 'classnames';
import { Button } from '@johnlewispartnership/wtr-ingredients/ingredients/Button';
import { CALLTOACTION_BUTTON_NAME } from '../../constants/analyticsNames';
import AnchorLink from '../../components/AnchorLink';
import { CALLTOACTION_BUTTON } from '../../constants/cmsResourceTypes';
import { usePromoClickEvent } from '../../hooks/use-promo-click-event';
import styles from './index.module.scss';
const CallToActionButton = ({ align, analytics, analyticsTags, ariaLabel, componentId, cqResponsiveClasses, link, position, theme, width, }) => {
    const promoClickEvent = usePromoClickEvent();
    if (!((link === null || link === void 0 ? void 0 : link.text) && (link === null || link === void 0 ? void 0 : link.url))) {
        return null;
    }
    const onClick = () => {
        promoClickEvent(Object.assign(Object.assign({}, analytics), { id: componentId, name: analytics === null || analytics === void 0 ? void 0 : analytics.promoName, position, creative: CALLTOACTION_BUTTON_NAME, linkUrl: link.url, newWindow: link.newWindow }));
    };
    return (React.createElement("div", Object.assign({ id: componentId, className: classnames(cqResponsiveClasses, styles.marginBottom, styles[align]) }, analyticsTags),
        React.createElement(Button, { type: undefined, component: AnchorLink, "aria-label": ariaLabel, href: link === null || link === void 0 ? void 0 : link.url, newWindow: link.newWindow, width: width, theme: theme === 'primaryLight' ? 'primaryWhite' : theme, label: link === null || link === void 0 ? void 0 : link.text, onClick: onClick })));
};
CallToActionButton.propTypes = {
    align: PropTypes.string,
    analytics: PropTypes.shape({
        promoName: PropTypes.string,
        promoType: PropTypes.string,
        promoPeriod: PropTypes.string,
        bannerPurpose: PropTypes.string,
        buyingOfficeAndGroup: PropTypes.string,
    }),
    analyticsTags: PropTypes.shape({}),
    ariaLabel: PropTypes.string,
    componentId: PropTypes.string,
    cqResponsiveClasses: PropTypes.arrayOf(PropTypes.string),
    link: PropTypes.shape({
        newWindow: PropTypes.bool,
        text: PropTypes.string,
        url: PropTypes.string,
    }),
    position: PropTypes.string,
    theme: PropTypes.string,
    width: PropTypes.string,
};
CallToActionButton.defaultProps = {
    align: undefined,
    analytics: undefined,
    analyticsTags: undefined,
    ariaLabel: undefined,
    componentId: undefined,
    cqResponsiveClasses: undefined,
    link: undefined,
    position: undefined,
    theme: undefined,
    width: undefined,
};
CallToActionButton.authorConfig = {
    emptyLabel: 'CTA Button',
    isEmpty: ({ link }) => !(link === null || link === void 0 ? void 0 : link.text),
};
CallToActionButton.displayName = CALLTOACTION_BUTTON_NAME;
CallToActionButton.resourceType = CALLTOACTION_BUTTON;
export default CallToActionButton;
//# sourceMappingURL=index.js.map